import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs';
import { API_BASE_URL } from '../api/api.config';

export interface SignInRequest { username: string; password: string; }

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly loggedInState = signal(sessionStorage.getItem('portbar.auth') === '1');
  private readonly userNameState = signal(sessionStorage.getItem('portbar.userName') ?? '');
  readonly loggedIn = this.loggedInState.asReadonly();
  readonly userName = this.userNameState.asReadonly();

  constructor(private readonly http: HttpClient) {}

  signIn(credentials: SignInRequest) {
    return this.http.post<unknown>(`${API_BASE_URL}/Breeze/SignIn`, credentials).pipe(
      tap(response => {
        const obj = (response ?? {}) as Record<string, unknown>;
        const name = (obj['FullName'] ?? obj['UserName'] ?? credentials.username) as string;
        sessionStorage.setItem('portbar.auth', '1');
        sessionStorage.setItem('portbar.userName', name);
        this.loggedInState.set(true);
        this.userNameState.set(name);
      })
    );
  }

  signOut(): void {
    sessionStorage.removeItem('portbar.auth');
    sessionStorage.removeItem('portbar.userName');
    this.loggedInState.set(false);
    this.userNameState.set('');
  }
}
